import React from "react";
import tripRequestLogo from "../../assets/images/trip_request_icon.svg";
import { Link } from "react-router-dom";
import { ExportOutlined } from "@ant-design/icons";
import CommonHeader from "../../components/elements/CommonHeader";
import ROUTE_PATHS from "../../utils/routePaths";
import {
  clearHistoricFiltersStorage,
  clearHistoricSearchStorage,
} from "../../utils/searchStorage";

const clearHistoricStorage = () => {
  clearHistoricSearchStorage();
  clearHistoricFiltersStorage();
};
const HistoricTripsHeader = ({
  currentPage,
  onExportRequest,
  isExportPending = false,
  isExportDisabled = true,
}) => {
  return (
    <CommonHeader
      centerLogoSrc={tripRequestLogo}
      headerText="Historic Trips"
      backContent={
        <div className="navigation-header">
          <Link
            to={ROUTE_PATHS.TRIP_REQUEST_PAGE}
            state={{ currentPage }}
            className="navigation-header-link"
            onClick={clearHistoricStorage}
          >
            Home/
          </Link>
          Historic Trips
        </div>
      }
      rightContent={
        <button
          type="button"
          className={`historic-trips-export-button ${isExportPending || isExportDisabled ? "historic-trips-export-button-disabled" : ""
            }`}
          onClick={onExportRequest}
          disabled={isExportPending || isExportDisabled}
        >
          <ExportOutlined className="historic-trips-export-button-icon" />
          {isExportPending ? "Exporting..." : "Export"}
        </button>
      }
    />
  );
};

export default HistoricTripsHeader;
